import { render, staticRenderFns } from "./PromotionLastMinuteUpdateForm.vue?vue&type=template&id=059165de&scoped=true&"
import script from "./PromotionLastMinuteUpdateForm.vue?vue&type=script&lang=js&"
export * from "./PromotionLastMinuteUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059165de",
  null
  
)

export default component.exports